import { throttle } from 'lodash';
import ready from './lib/ready';
import Sticky from './sticky/index'

ready(() => {
  [].forEach.call(
    document.querySelectorAll('[data-js-index-menu]'),
    function (elem) {
      document.documentElement.style.setProperty('--offsetTop', (elem.offsetTop + elem.offsetHeight + 20) + 'px')
      const dropBtn = elem.querySelector('[data-js-dropdown]')
      const offset = 250;

      // Btn close panel
      const links = elem.querySelectorAll('a[href]');
      if (0 != links.length) {
        [].forEach.call(links, (link) => {

          link.addEventListener("click", (e) => {
            [].forEach.call(links, (link) => {
              link.classList.remove('is-active')
            })

            link.classList.add('is-active')

            const closeEvent = new CustomEvent('close.drop')
            dropBtn.dispatchEvent(closeEvent)
          });
        });
      }


      function setCurrentMenuItemActive() {
        const t = window.scrollY + offset;

        for (const n of links) {
          Array.from(links).map((link, i) => {
            const o = document.querySelector(link.getAttribute("href")).offsetTop;

            if (links[i + 1]) {
              const r = links[i + 1]
              const a = document.querySelector(r.getAttribute("href")).offsetTop

              o <= t && a > t ? (n.classList.remove("is-active"), link.classList.add("is-active")) : link.classList.remove("is-active");
            } else o <= t ? (n.classList.remove("is-active"), links[links.length - 1].classList.add("is-active")) : link.classList.remove("is-active");
          });
        }
      }

      window.addEventListener('scroll', throttle(setCurrentMenuItemActive, 500))

      elem.sticky = new Sticky(elem, {
        offset: 20
      });
    }
  )
})
